<template>
  <div class="login">
    <div class="container">
      <v-snackbar v-model="loginSuccess" color="success" top>
        <span class="subtitle-1">Sucesso! Acessando sistema...</span>
      </v-snackbar>

      <v-snackbar color="error" v-model="loginFail" top>
        <span class="subtitle-1">
          {{messageFail}}
        </span>
        <v-btn text class="white--text"
               @click="loginFail = false"
        >
          Fechar
        </v-btn>
      </v-snackbar>

      <h1 class="display-1 my-3">Acesso ao sistema</h1>
      <v-divider></v-divider>
      <v-row wrap justify="center">
         
        <v-flex xs12 sm6 xl3>
          <v-card hover class="ma-3">
            <v-card-title>Certificado Digital</v-card-title>
            <v-card-text>
              <p class="body-2">
                Acesso para usuários que possuem documento eletrônico de
                identidade emitido por Autoridade Certificadora credenciada pela
                Autoridade Certificadora Raiz da ICP-Brasil.
              </p>
              <p>
                <strong class="red--text">ATENÇÃO:</strong> Para acesso a
                solução DESIF fazendo uso desta certificação, se faz necessário
                que o computador utilizado para acesso possua instalado a versão
                mais recente do software Java, um conjunto de ferramentas que
                permite a execução desses aplicativos.
              </p>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn
                small
                block
                color="#006eb8"
                dark
                type="submit"
                :href="linkCertificadoDigital"
              >
                <v-icon small left>account_balance_wallet</v-icon>
                <span>Utilizar certificado</span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-row>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mask } from "vue-the-mask";
import crypto from "crypto-js";

export default {
  directives: { mask },
  data() {
    return {
      cpfCnpj: "",
      senha: "",
      regrasCPF: [(v) => !!v || "Campo obrigatório!"],
      regrasSenha: [(v) => !!v || "Campo obrigatório!"],
      mostrarSenha: false,
      loginSuccess: false,
      loginFail: false,
      messageFail: "",
      linkCadastro: "",
      linkCertificadoDigital: "Alguma coisa",
    };
  },
  created() {
    const protocol = window.location.protocol;
    const hostname = window.location.hostname;
    const port = window.location.port == "8081" ? "8080" : window.location.port;
    const base_URL = `${protocol}//${hostname}:${port}/dec/paginas/credenciamento/listaCredenciamento.jsf`;
    this.linkCadastro = base_URL;
    this.linkCertificadoDigital = `${protocol}//${hostname}:${port}/desif-web/certificadodigital/`;
  },
  methods: {
/*
    acessarSistema() {
      const protocol = window.location.protocol;
      const hostname = window.location.hostname;
      const port = window.location.port == "8081" ? "8080" : window.location.port;
      axios.defaults.baseURL = `${protocol}//${hostname}:${port}/controleacesso/`;

      if (!this.$refs.form.validate()) {
        // console.log("Erro!");
      } else {
        this.cpfCnpj = this.removeMask();

        const loginForm = {
          login: this.cpfCnpj,
          password: crypto.MD5(this.senha).toString(),
          identificacaoSistema: "DSF_DEC",
          verificaSessao: false,
        };

        axios
          .post("servico/api/login", loginForm)
          .then((res) => {
            const token = res.data;
            this.loginSuccess = true;
            window.location.replace(
              `${protocol}//${hostname}:${port}/dec/paginas/login/login.jsf?token=${token}`
            );
          })
          .catch((error) => {
            console.log(error);
            this.loginFail = true;
            this.messageFail = error.response.data;
          });
      }
    },

 */

    acessarSistema() {
      const protocol = window.location.protocol;
      const hostname = window.location.hostname;
      const port = window.location.port == "8081" ? "8080" : window.location.port;
      const baseUrl = `${protocol}//${hostname}:${port}`;
      axios.defaults.baseURL = `${baseUrl}/controleacesso`;

      if (!this.$refs.form.validate()) {
        console.log("Erro!");
        this.$refs.recaptcha.reset();
      } else {
        this.cpfCnpj = this.removeMask();

        const loginform = {
          login: this.cpfCnpj,
          password: crypto.MD5(this.senha).toString(),
          //identificacaoSistema: "DSF_DEC",
          identificacaoSistema: "DESIF_EXTERNO",
          verificaSessao: false,
        };

        axios
            .post("api/v2/login", loginform)
            .then((res) => {
              // console.log(res.data);
              this.loginSuccess = true;
              this.loginFail = false;
              const token = res.data;
              window.location.replace(`${baseUrl}/dec/paginas/login/login.jsf?token=${token}`);
            })
            .catch((error) => {
              console.log(error);
              this.loginFail = true;
              this.messageFail = error.response.data;
            });
      }
    },

    removeMask() {
      return this.cpfCnpj.replace(/\D/g, "");
    },
  },
};
</script>
